import { render, staticRenderFns } from "./HrContractStructureList.vue?vue&type=template&id=2c4a827a&lang=pug&"
import script from "./HrContractStructureList.vue?vue&type=script&lang=js&"
export * from "./HrContractStructureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrContractStructureList.vue"
export default component.exports